import Button from "../../Components/Button";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { useMutation } from "react-query";
import { editProfileSchema } from "../../Schema/profileSchema";
import useFileReader from "../../Hooks/useFileReader";
import { updateProfile } from "../../Services/Profile";
import { setUser } from "../../Redux/slice";
import { ImageWrapper } from "../../Services/General";
import { Error } from "../../Components/Modal";
import BackButton from "../../Components/BackButton";

export default function EditProfile() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { getThumbnail } = useFileReader();
    const [selectedFile, setSelectedFile] = useState(null);
    const [image, setImage] = useState("");
    const { user } = useSelector((state) => state?.slice);
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm({
        resolver: yupResolver(editProfileSchema),
    });

    useEffect(() => {
        if (user?.profileImage) {
            setSelectedFile(user?.profileImage?.imageUrl);
        }
        reset({
            name: user?.firstName,
        });
    }, [user, reset]);

    const { mutate, isLoading } = useMutation((data) => updateProfile(data), {
        retry: false,
        onSuccess: (res) => {
            dispatch(setUser(res.data?.user));
            navigate("/profile");
        },
        onError: (err) => {
            Error(err.response.data?.message);
        },
    });

    const handleUploadImage = async (e) => {
        let file = e.target?.files?.[0];
        if (file) {
            let fileThumbnail = await getThumbnail(file);
            setSelectedFile(fileThumbnail);
            setImage(file);
        }
    };

    const submit = (data) => {
        const apiformData = new FormData();
        apiformData.append("image", image);

        ImageWrapper(
            user?._id,
            apiformData,
            user?.profileImage?.imageUrl,
            (image) => {
                mutate({
                    firstName: data?.name,
                    profileImage: image?._id,
                });
            }
        );
    };

    return (
        <div className="app-content content dashboard">
            <div className="content-wrapper">
                <div className="content-body">
                    <section id="configuration">
                        <div className="user-details-wrapper">
                            <div className="row mb-4">
                                <div className="col-12">
                                    <div className="back-title">
                                        <BackButton />
                                        <h1 className="pageTitle m-0">Edit Profile</h1>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-10 col-xl-8">
                                    <div className="details-card-premium p-4 p-lg-5">
                                        <form onSubmit={handleSubmit(submit)}>
                                            <div className="text-center mb-5">
                                                <div className="userIimageFrame mx-auto mb-3 position-relative shadow" style={{ width: '130px', height: '130px', borderRadius: '50%', border: '4px solid #fff', overflow: 'visible' }}>
                                                    <img
                                                        src={selectedFile ?? "images/avatar.png"}
                                                        alt=""
                                                        className="img-fluid w-100 h-100 object-fit-cover rounded-circle shadow-sm"
                                                    />
                                                    <label htmlFor="userImage" className="uploadCamera position-absolute bg-primary text-white rounded-circle d-flex align-items-center justify-content-center shadow" style={{ width: '38px', height: '38px', cursor: 'pointer', border: '3px solid #fff', bottom: '5px', right: '5px', zIndex: '2' }}>
                                                        <i className="fas fa-camera" style={{ fontSize: '16px' }} />
                                                    </label>
                                                    <input
                                                        type="file"
                                                        id="userImage"
                                                        accept="image/*"
                                                        className="d-none"
                                                        onChange={handleUploadImage}
                                                    />
                                                </div>
                                                <p className="text-muted small fw-semibold mt-3">Tap camera icon to change photo</p>
                                            </div>

                                            <div className="mainDetail">
                                                <label className="mainLabel">Name <span className="text-danger">*</span></label>
                                                <div className="flex-grow-1">
                                                    <input
                                                        type="text"
                                                        className="dashInput"
                                                        placeholder="Enter your name"
                                                        {...register("name")}
                                                    />
                                                    {errors?.name && <span className="text-danger small d-block mt-1">{errors?.name?.message}</span>}
                                                </div>
                                            </div>

                                            <div className="mt-5 text-end">
                                                <Button
                                                    type="submit"
                                                    className="siteBtn px-5"
                                                    loading={isLoading}
                                                >
                                                    Save Changes
                                                </Button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}
